import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = ''
}: ButtonProps) {
  return <a href="https://www.etsy.com/listing/4490149718/wedding-nfc-sign-tap-to-share-photos-qr" target="_blank" rel="noopener noreferrer" className={`inline-flex items-center justify-center px-8 py-4 bg-gold hover:bg-gold-light text-dark font-semibold rounded-full transition-all duration-300 shadow-[0_0_20px_rgba(201,168,76,0.2)] hover:shadow-[0_0_30px_rgba(212,175,55,0.4)] hover:-translate-y-1 ${className}`} data-id="element-16">
      {children}
    </a>;
}